// layout.js
import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import Header from "./Header";
import "../css/css_layouts/layout.css";

const Layout = ({ setIsLoggedIn }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [headerVisible, setHeaderVisible] = useState(true);

  const handleLogout = () => {
    setIsLoggedIn(false);
  };

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const toggleHeader = () => {
    setHeaderVisible(!headerVisible);
  };

  return (
    <div className="layout">
      <Sidebar
        isOpen={sidebarOpen}
        setIsOpen={setSidebarOpen}
        handleLogout={handleLogout}
        headerVisible={headerVisible}
        toggleHeader={toggleHeader}
      />
      <div className="main">
        {headerVisible && <Header toggleSidebar={toggleSidebar} />}
        <div className={`content ${!headerVisible ? 'header-hidden' : ''}`}>
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default Layout;